// import React from 'react';
// import { 
//   Coins, Handshake, Scale, ShieldAlert, 
//   TrendingDown, FileClock, ChevronLeft, 
//   Briefcase, CheckCircle2, Building2 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function DebtCollection() {
  
//   // Core collection strategies and offerings
//   const collectionServices = [
//     {
//       title: "التحصيل الودي والتفاوض",
//       desc: "التواصل الدبلوماسي الحازم مع المدينين، وصياغة اتفاقيات جدولة الديون والتسويات الملزمة التي تضمن التدفق النقدي دون خسارة العلاقات التجارية.",
//       icon: <Handshake className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تحصيل الديون التجارية والشركات",
//       desc: "إدارة وملاحقة الذمم المدينة المتعثرة بين الشركات والموردين (B2B)، ومراجعة العقود والاعتمادات المستندية لتقليص حجم الديون المعدومة.",
//       icon: <Building2 className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "ملاحقة الأوراق التجارية المتعثرة",
//       desc: "تحصيل الشيكات المرتجعة، السندات لأمر، والكمبيالات المتأخرة، واتخاذ الإجراءات القانونية السريعة لتحويلها إلى طلبات تنفيذية نافذة.",
//       icon: <Coins className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "التحصيل القضائي الجبري",
//       desc: "رفع دعاوى المطالبة المالية أمام المحاكم التجارية والعمالية، ومتابعة تنفيذ الأحكام قطعية النفاذ عبر فرض الحجوزات البنكية وتتبع الأصول.",
//       icon: <Scale className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات إدارة وتحصيل الديون المتعثرة"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />  
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">حماية تدفقاتك النقدية واسترداد أموالك</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات إدارة وتحصيل الديون المتعثرة</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نحن ندرك أن تأخر تحصيل المستحقات المالية يهدد استقرار منشأتك. لذلك، نوظف خبرتنا القانونية وأدواتنا الإجرائية المبتكرة لاستعادة ديونك بكفاءة وسرعة، مع الالتزام التام بالأنظمة واللوائح المعتمدة.
//           </p>
//         </div>
//       </section>

//       {/* Methodology & Strategy Analysis */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               نهج ذكي يوازن بين الحفاظ على الشراكة وقوة القانون
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               لا نعتمد في مكتبنا على الأساليب التقليدية المجهدة؛ بل نسير وفق استراتيجية مدروسة تبدأ بالتقييم الائتماني للمدين، وتحليل قدرته المليئة، وتحديد مواطن القوة القانونية في مستندات المديونية.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               إذا أظهر المدين مرونة، نجري معه تسوية ودية موثقة بضمانات تنفيذية مشددة. أما في حال المماطلة والامتناع، فإننا ننتقل فوراً إلى التصعيد القضائي وإصدار أوامر الحجز، والمنع من السفر، تفعيلاً للمساطر النظامية الصارمة التي تكفل استرجاع كامل الحقوق مضافاً إليها التعويضات إن أمكن.
//             </p>
//           </div>
          
//           {/* Performance Metrics / Value Box */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <TrendingDown className="w-5 h-5 text-amber-600" /> لماذا تسند ملف التحصيل لمكتبنا؟
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**توفير الجهد والوقت:** نتحمل عن كاهل قسمك المالي عبء الملاحقة والاتصال والتدقيق المستمر.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**صياغة تسويات آمنة:** تحويل الديون العادية إلى سندات تنفيذية تمنع المدين من إثارة النزاعات الموضوعية لاحقاً.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle2 className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">**تغطية جغرافية واسعة:** ملاحقة المدينين وتتبع أصولهم وعقاراتهم في مختلف مناطق المملكة.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Scope of Services */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">حلول متكاملة لكافة مستويات المديونيات</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">من التنبيه الودي الأول وحتى البيع بالمزاد العلني وتسييل الأصول الجبرية</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {collectionServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Warning/Regulatory Checklist */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه قانوني بشأن تقادم الديون:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               إن التراخي في ملاحقة المدينين قد يؤدي إلى سقوط الحجية التنفيذية للأوراق التجارية (مثل الشيكات والسندات لأمر) بمرور المدد النظامية للتقادم، مما يضطرك لخوض مسار قضائي موضوعي طويل ومطول. نوصي دوماً ببدء إجراءات التحصيل والملاحقة فور حلول أجل الدين لضمان كامل حقوقك.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Action Banner */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <FileClock className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل لديك ديون متعثرة ترغب في استعادتها؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           قدم لنا تفاصيل المديونية والمستندات المؤيدة لها، وسيتولى فريقنا دراسة الملف وإعداد خطة تحصيل عاجلة تتناسب مع طبيعة الديون وحالة المدين.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب استشارة لتحصيل الديون
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  Coins, Handshake, Scale, ShieldAlert, 
  TrendingDown, FileClock, ChevronLeft, 
  Briefcase, CheckCircle2, Building2 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function DebtCollection() {
  
  // Core collection strategies and offerings - Refactored to Navy Light
  const collectionServices = [
    {
      title: "التحصيل الودي والتفاوض",
      desc: "التواصل الدبلوماسي الحازم مع المدينين، وصياغة اتفاقيات جدولة الديون والتسويات الملزمة التي تضمن التدفق النقدي دون خسارة العلاقات التجارية.",
      icon: <Handshake className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تحصيل الديون التجارية والشركات",
      desc: "إدارة وملاحقة الذمم المدينة المتعثرة بين الشركات والموردين (B2B)، ومراجعة العقود والاعتمادات المستندية لتقليص حجم الديون المعدومة.",
      icon: <Building2 className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "ملاحقة الأوراق التجارية المتعثرة",
      desc: "تحصيل الشيكات المرتجعة، السندات لأمر، والكمبيالات المتأخرة، واتخاذ الإجراءات القانونية السريعة لتحويلها إلى طلبات تنفيذية نافذة.",
      icon: <Coins className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "التحصيل القضائي الجبري",
      desc: "رفع دعاوى المطالبة المالية أمام المحاكم التجارية والعمالية، ومتابعة تنفيذ الأحكام قطعية النفاذ عبر فرض الحجوزات البنكية وتتبع الأصول.",
      icon: <Scale className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات إدارة وتحصيل الديون المتعثرة"
        description="نقدم حلولاً قانونية شاملة لدعم التدفقات النقدية واستقرار منشآت الأعمال في السوق السعودي"
      />  
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">حماية تدفقاتك النقدية واسترداد أموالك</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات إدارة وتحصيل الديون المتعثرة</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نحن ندرك أن تأخر تحصيل المستحقات المالية يهدد استقرار منشأتك. لذلك، نوظف خبرتنا القانونية وأدواتنا الإجرائية المبتكرة لاستعادة ديونك بكفاءة وسرعة، مع الالتزام التام بالأنظمة واللوائح المعتمدة.
          </p>
        </div>
      </section>

      {/* Methodology & Strategy Analysis */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              نهج ذكي يوازن بين الحفاظ على الشراكة وقوة القانون
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              لا نعتمد في مكتبنا على الأساليب التقليدية المجهدة؛ بل نسير وفق استراتيجية مدروسة تبدأ بالتقييم الائتماني للمدين، وتحليل قدرته المليئة، وتحديد مواطن القوة القانونية في مستندات المديونية.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              إذا أظهر المدين مرونة، نجري معه تسوية ودية موثقة بضمانات تنفيذية مششدة. أما في حال المماطلة والامتناع، فإننا ننتقل فوراً إلى التصعيد القضائي وإصدار أوامر الحجز، والمنع من السفر، تفعيلاً للمساطر النظامية الصارمة التي تكفل استرجاع كامل الحقوق مضافاً إليها التعويضات إن أمكن.
            </p>
          </div>
          
          {/* Performance Metrics / Value Box - Navy Light Theme */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <TrendingDown className="w-5 h-5 text-blue-700" /> لماذا تسند ملف التحصيل لمكتبنا؟
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">توفير الجهد والوقت:</strong> نتحمل عن كاهل قسمك المالي عبء الملاحقة والاتصال والتدقيق المستمر.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">صياغة تسويات آمنة:</strong> تحويل الديون العادية إلى سندات تنفيذية تمنع المدين من إثارة النزاعات الموضوعية لاحقاً.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle2 className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light"><strong className="font-bold text-indigo-950">تغطية جغرافية واسعة:</strong> ملاحقة المدينين وتتبع أصولهم وعقاراتهم في مختلف مناطق المملكة.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Grid: Scope of Services - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">حلول متكاملة لكافة مستويات المديونيات</h2>
            <p className="text-slate-500 max-w-xl mx-auto text-sm md:text-base font-light">من التنبيه الودي الأول وحتى البيع بالمزاد العلني وتسييل الأصول الجبرية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {collectionServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Warning/Regulatory Checklist - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-16 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه قانوني بشأن تقادم الديون:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إن التراخي في ملاحقة المدينين قد يؤدي إلى سقوط الحجية التنفيذية للأوراق التجارية (مثل الشيكات والسندات لأمر) بمرور المدد النظامية للتقادم، مما يضطرك لخوض مسار قضائي موضوعي طويل ومطول. نوصي دوماً ببدء إجراءات التحصيل والملاحقة فور حلول أجل الدين لضمان كامل حقوقك.
            </p>
          </div>
        </div>
      </section>

      {/* Action Banner - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <FileClock className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل لديك ديون متعثرة ترغب في استعادتها؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          قدم لنا تفاصيل المديونية والمستندات المؤيدة لها، وسيتولى فريقنا دراسة الملف وإعداد خطة تحصيل عاجلة تتناسب مع طبيعة الديون وحالة المدين.
        </p>
        <button 
          onClick={() => openWhatsApp( "   طلب استشارة لتحصيل الديون     ")}
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب استشارة لتحصيل الديون
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}